import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    closeMenu();
  };

  return (
    <header>
      <nav>
        <Link to="/" className="logo" onClick={closeMenu}>
          FH Consulting
        </Link>
        
        <div 
          className="nav-toggle" 
          aria-label="Menü öffnen" 
          role="button" 
          tabIndex="0"
          onClick={toggleMenu}
          onKeyDown={(e) => e.key === 'Enter' && toggleMenu()}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <ul className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
          <li>
            <button 
              onClick={() => scrollToSection('home')}
              className="nav-link-button"
            >
              Start
            </button>
          </li>
          <li>
            <button 
              onClick={() => scrollToSection('about')}
              className="nav-link-button"
            >
              Warum wir
            </button>
          </li>
          <li>
            <button 
              onClick={() => scrollToSection('services')}
              className="nav-link-button"
            >
              Leistungen
            </button>
          </li>
          <li>
            <Link to="/contact" onClick={closeMenu}>
              Kontakt
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
